import { createFileRoute } from '@tanstack/react-router';
import { LoyaltyAddPage } from './LoyaltyAddPage';

export const Route = createFileRoute('/_protected/admin/loyalty/add/')({
  component: LoyaltyAddPage,
});
